import React, { useEffect, useState } from 'react';

import Grid from '@mui/material/Grid2';

import { DisablableOption } from "@models";
import { 
  BastionAbility,
  Character,
  CharacterBastionFacility,
  Money,
  TrueCreatureInstance,
} from "@dndModels";

// import DataUtilities from '../../../utilities/common_utilities';
import DandDCharacterUtilities from "@dndUtilities/char_utilities";

import SelectStringBox from "@components/input/selects/SelectStringBox";
import DisplayStringWithReplacements from "@dndComponents/display/DisplayStringWithReplacements";
import LoadingBox from "@components/input/LoadingBox";
import ButtonBox from "@components/input/buttons/ButtonBox";
import CharConnectUtilities from '@dndUtilities/char_connect_utilities';

interface Props {
  char: Character;
  char_bf: CharacterBastionFacility;
  bfa: BastionAbility;
}

// const common_util = DataUtilities.getInstance();
const char_util = DandDCharacterUtilities.getInstance();
const connect_util = CharConnectUtilities.getInstance();

export default function CharacterBastionAbilityInput({
  char,
  char_bf,
  bfa
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState<DisablableOption[]>([]);
  const [selected_id, setSelectedID] = useState("");
  // const [processing, setProcessing] = useState(false);

  useEffect(() => {
    if (!fetched) {
      setFetched(true);
      setLoading(true);
      // debugger;
      char_util.getBFAItemOptions(char, char_bf, bfa).then(res => {
        setOptions(res);
        if (res.length === 1) {
          setSelectedID(res[0].id);
        }
        setLoading(false);
      });
    }
  }, [fetched, char, char_bf, bfa]);
  
  const renderControls = () => {
    const opt = options.find(o => o.id === selected_id);
    const gold_cost = opt?.hidden_num2;
    switch (bfa.type) {
      case "Craft": 
      case "Harvest": 
      case "Trade": 
      case "Recruit":
        // Item or Creature selection and costs
        return (
          <>
            <Grid
              size={{
                xs: 4
              }}>
              { options.length === 1 ? options[0].text : 
                <SelectStringBox
                  name={`Options`}
                  options={options}
                  value={selected_id}
                  onChange={setSelectedID}
                />
              }
            </Grid>
            { renderGetButtons(gold_cost) }
          </>
        );
      case "Research":
        // Nothing?
      break;
      case "Empower": 
      case "Other":
        // Gift selection and costs
      break;
    }
    return <></>;
  }

  const renderGetButtons = (gold_cost?: number) => {
    if (gold_cost) {
      return (
        <>
          <Grid
            size={{
              xs: 2
            }}>
            <ButtonBox
              name={ `${bfa.type === "Trade" ? "Purchase" : bfa.type} for ${gold_cost}gp` }
              disabled={ gold_cost > char.money.gold_value() }
              onClick={ async () => {
                await getSelected(true);
              }}
            />
          </Grid>
          <Grid
            size={{
              xs: 2
            }}>
            <ButtonBox
              name={ `${bfa.type === "Trade" ? "Purchase" : bfa.type} for free` }
              onClick={ async () => {
                await getSelected(false);
              }}
            />
          </Grid>
        </>
      );
    } else {
      return (
        <>
          <Grid
            size={{
              xs: 4
            }}>
            <ButtonBox
              name={ `${bfa.type === "Trade" ? "Purchase" : bfa.type}` }
              onClick={ async () => {
                await getSelected(false);
              }}
            />
          </Grid>
        </>
      );
    }
  }

  const getSelected = async (pay_cost: boolean) => {
    const opt = options.find(o => o.id === selected_id);
    if (opt) {
      // switch (bfa.type) {
      //   case "Craft":
      //   case "Harvest":
      //   case "Recruit":
      //   case "Trade":
      // Add it to facility
      if (opt.hidden_num2 && pay_cost) {
        const cost = new Money();
        cost.copyGoldValue(opt.hidden_num2);
        char.money.subtract(cost);
        char.subscription_holder.itemsChanged();
      }
      if (opt.hidden1 === "Item") {
        // Add it to inventory
        const item = char_util.getPseudoItem(selected_id);
        if (item) {
          await connect_util.addItem({ char, item, count: opt.hidden_num1 ? opt.hidden_num1 : 1, char_bf });
        }
      } else if (opt.hidden1 === "Creature") {
        const creatures = await char_util.getCreatures({ char });
        const creature = creatures.find(o => o._id === selected_id);
        if (creature) {
          const ci = new TrueCreatureInstance();
          // await ci.copyCreature(creature);
          // if (opt.hidden_num2) {
          //   ci.value = opt.hidden_num2;
          // }
          char_bf.creatures.push(ci);
          char.changed();
        }
      } else if (opt.hidden1 === "Custom") {
        const item = bfa.items.find(o => o.custom_options.find(o => o.true_id === selected_id));
        const custom = item?.custom_options.find(o => o.true_id === selected_id)??undefined;
        if (custom) {
          char_bf.customs.push({
            id: selected_id, 
            name: opt.text,
            count: custom.count,
            value: custom.value
          });
          char.changed();
        }
      }
      char.subscription_holder.bastionChanged();
      //   break;
      // }
    }
  }

  if (!fetched || loading) {
    return (<LoadingBox />);
  } else {
    return (
      <Grid container spacing={0} direction="row">
        <Grid
          className="header padded"
          size={{
            xs: 4
          }}>{ bfa.name }</Grid>
        { renderControls() }
        <Grid
          className="padded"
          size={{
            xs: 12
          }}>
          <DisplayStringWithReplacements display_string={ bfa.description } cfs={char} />
        </Grid>
      </Grid>
    );
  }
}
